import type { FC, SVGProps } from "react";
import { renderToStaticMarkup } from "react-dom/server";

import { LIVE_MAP_INCIDENT } from "@ryde/assets";

import type { TLiveMapIncidentMarkerIconType } from "./live-map.incident-marker.models";

const MARKER_ICON_SIZE = 30;

const iconSvgProps = (): SVGProps<SVGSVGElement> => ({
  width: MARKER_ICON_SIZE,
  height: MARKER_ICON_SIZE,
});

const INCIDENT_MARKER_ICON_COMPONENT: Record<
  TLiveMapIncidentMarkerIconType,
  FC<SVGProps<SVGSVGElement>>
> = {
  security: LIVE_MAP_INCIDENT.LiveMapIncidentSecuritySVG,
  repair: LIVE_MAP_INCIDENT.LiveMapIncidentRepairSVG,
  ride_event: LIVE_MAP_INCIDENT.LiveMapIncidentRideEventSVG,
  road_block: LIVE_MAP_INCIDENT.LiveMapIncidentRoadBlockSVG,
};

export const buildTypedIncidentMarkerIconSvg = (
  iconType: TLiveMapIncidentMarkerIconType,
): string => {
  const Icon = INCIDENT_MARKER_ICON_COMPONENT[iconType];

  return renderToStaticMarkup(<Icon {...iconSvgProps()} />);
};
